import { IConfiguration } from '.';
import {
    TBooleanConfigEntries,
    TConfigurationDTO,
    TNumberConfigEntries,
    TStringConfigEntries,
} from './types';

export class Configuration implements IConfiguration {
    private readonly configurationValues: {};

    constructor(configurationValues: TConfigurationDTO) {
        this.configurationValues = Object.keys(configurationValues).reduce(function(newObj, key) {
            newObj[key.toLowerCase()] = configurationValues[key];
            return newObj;
        }, {});
    }

    private getConfigurationValueForKey(key: string) {
        return this.configurationValues[key.toLowerCase()];
    }

    getStringValue(key: TStringConfigEntries) {
        return this.getStringValueOrDefault(key, undefined);
    }

    getStringValueOrDefault<TDefault = string>(
        key: TStringConfigEntries,
        defaultValue: TDefault
    ): string | TDefault {
        const value = this.getConfigurationValueForKey(key);

        if (value !== undefined) {
            return value;
        }

        return defaultValue;
    }

    getBooleanValue(key: TBooleanConfigEntries): boolean | undefined {
        return this.getBooleanValueOrDefault(key, undefined);
    }

    getBooleanValueOrDefault<TDefault = boolean>(
        key: TBooleanConfigEntries,
        defaultValue: TDefault
    ): boolean | TDefault {
        const value = this.getConfigurationValueForKey(key);

        if (value !== undefined) {
            return value.toLowerCase() === 'true';
        }

        return defaultValue;
    }

    getNumberValue(key: TNumberConfigEntries): number | undefined {
        return this.getNumberValueOrDefault(key, undefined);
    }

    getNumberValueOrDefault<TDefault = number>(
        key: TNumberConfigEntries,
        defaultValue: TDefault
    ): number | TDefault {
        const value = this.getConfigurationValueForKey(key);

        if (value !== undefined) {
            return parseFloat(value);
        }

        return defaultValue;
    }
}
